"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "carceri": {
    "d2c0c909": [{
      "hkey": "722af227",
      "slug": "santa-caterina-d-este",
      "name": "Santa Caterina d'Este",
      "primary": true,
      "skipSearch": false
    }],
    "carceri": [{
      "hkey": "722af227",
      "slug": "santa-caterina-d-este",
      "name": "Santa Caterina d'Este",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;